import Typography, { TypographyProps } from '@mui/material/Typography';

export const P = (props: TypographyProps) => {
    const { children, ...rest } = props;
    return <Typography paragraph sx={{ mt: '1em', mb: '1em' }} { ...rest }>{props.children}</Typography>;
}